import { environment } from 'environments/environment';
import { Component } from '@angular/core';

@Component({
  selector: 'landing-app-store-button',
  templateUrl: './app-store-button.component.html',
  styleUrls: ['./app-store-button.component.scss']
})
export class AppStoreButtonComponent {
  url = environment.iOSAppLink;
}
